import { useState } from "react";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import BadgeIcon from "@mui/icons-material/Badge";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { Sidebar } from "../../components/sidebar";
import { Snackbar } from "../../components/snackbar";
import { registerUser } from "../../services/user";
import { validateEmail } from "../../utils";
import { Wrapper } from "../../components/wrapper";
import {
  DEFAULT_SNACK,
  EMPTY_CREDENTIALS,
  ERROR_REGISTER,
  EXISTING_USER,
  INVALID_EMAIL,
  SUCCESS_REGISTER,
} from "../../utils/snacks";
import { DEFAULT_USER } from "../../utils/states";

export const Newuser = () => {
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="w-full p-4 bg-sidebar-bg">
        <Wrapper>
          <Form />
        </Wrapper>
      </div>
    </div>
  );
};

const Form = () => {
  const roles = ["admin", "user"];
  const [snack, setSnackbar] = useState(DEFAULT_SNACK);
  const [data, setData] = useState(DEFAULT_USER);

  const resetSnackbar = () => {
    setTimeout(() => {
      setSnackbar(DEFAULT_SNACK);
    }, 2000);
  };

  const handleChange = ({ target: { name, value } }) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleRole = ({ target: { value } }) => {
    setData({
      ...data,
      role: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isEmpty = Object.values(data).some((v) => v === "");
    if (isEmpty) {
      setSnackbar(EMPTY_CREDENTIALS);
      resetSnackbar();
      return;
    }
    if (!validateEmail(data.email)) {
      setSnackbar(INVALID_EMAIL);
      resetSnackbar();
      return;
    }
    try {
      let newUser = await registerUser(data);
      if (newUser.code === 409) {
        setSnackbar(EXISTING_USER);
        resetSnackbar();
        return;
      }
      setData(DEFAULT_USER);
      setSnackbar(SUCCESS_REGISTER);
      resetSnackbar();
      return newUser;
    } catch (e) {
      console.log("e: ", e);
      setSnackbar(ERROR_REGISTER);
      resetSnackbar();
    }
  };

  return (
    <>
      <div className="w-full max-w-7xl mx-auto px-4 lg:px-6 py-8">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-lg bg-blue-600 flex items-center justify-center">
              <PersonAddIcon className="text-white" fontSize="small" />
            </div>
            <h1 className="text-3xl font-bold text-white">Nuevo Usuario</h1>
          </div>
          <p className="text-gray-400 text-sm mt-1">
            Registra un nuevo usuario en el sistema
          </p>
        </div>

        <div className="bg-sidebar-bg rounded-xl shadow-sm border border-sidebar-accent p-6 lg:p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="text-sm font-medium text-gray-300 flex items-center gap-2">
                  <BadgeIcon fontSize="small" className="text-gray-400" />
                  Nombre
                </label>
                <input
                  type="text"
                  name="name"
                  value={data.name}
                  onChange={handleChange}
                  placeholder="Ingrese el nombre"
                  className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all text-gray-900 placeholder:text-gray-400"
                />
              </div>

              <div className="space-y-2">
                <label className="text-sm font-medium text-gray-300 flex items-center gap-2">
                  <BadgeIcon fontSize="small" className="text-gray-400" />
                  Apellido
                </label>
                <input
                  type="text"
                  name="last_name"
                  value={data.last_name}
                  onChange={handleChange}
                  placeholder="Ingrese el apellido"
                  className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all text-gray-900 placeholder:text-gray-400"
                />
              </div>

              <div className="space-y-2">
                <label className="text-sm font-medium text-gray-300 flex items-center gap-2">
                  <EmailIcon fontSize="small" className="text-gray-400" />
                  Correo Electrónico
                </label>
                <input
                  type="email"
                  name="email"
                  value={data.email}
                  onChange={handleChange}
                  placeholder="correo@ejemplo.com"
                  className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all text-gray-900 placeholder:text-gray-400"
                />
              </div>

              <div className="space-y-2">
                <label className="text-sm font-medium text-gray-300 flex items-center gap-2">
                  <LockIcon fontSize="small" className="text-gray-400" />
                  Contraseña
                </label>
                <input
                  type="password"
                  name="password"
                  value={data.password}
                  onChange={handleChange}
                  placeholder="Mínimo 6 caracteres"
                  minLength={6}
                  className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all text-gray-900 placeholder:text-gray-400"
                />
              </div>
            </div>

            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-300 flex items-center gap-2">
                <AdminPanelSettingsIcon
                  fontSize="small"
                  className="text-gray-400"
                />
                Rol
              </label>
              <select
                onChange={handleRole}
                value={data.role}
                className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all text-gray-900 bg-white"
              >
                <option value="">Seleccione un rol</option>
                {roles.map((r, idx) => (
                  <option value={r} key={idx}>
                    {r.charAt(0).toUpperCase() + r.slice(1)}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex justify-end pt-4">
              <button
                type="submit"
                className="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-200 flex items-center gap-2 shadow-sm hover:shadow-md"
              >
                <PersonAddIcon fontSize="small" />
                Registrar Usuario
              </button>
            </div>
          </form>
        </div>
      </div>

      <Snackbar
        severity={snack.severity}
        message={snack.message}
        visible={snack.visible}
      />
    </>
  );
};
